module.exports = __webpack_public_path__ + "static/media/image5.fecd8d15.jpg";